<template>
  <div class="page-card-wrapper page-card-wrapper-adapt-actual-width">
    <div class="page-card-title">
      <span class="page-card-title-text">{{ $t('text.observation') }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-20 max-w-800" style="margin: 0 auto;">
        <el-tabs type="border-card" v-model="activeTab">
          <el-tab-pane :label="$t('text.common_area')" name="common_area">
            <el-table
              border
              size="mini"
              height="calc(100vh - 300px)"
              max-height="800"
              :data="organisations"
              v-loading="loading"
            >
              <el-table-column
                :label="$t('text.name')"
                prop="OrganisationName.Name"
              >
              </el-table-column>
              <el-table-column :label="$t('text.action')">
                <template slot-scope="scope">
                  <div
                    class="blue-font underline pointer inline-block"
                    @click="
                      openQRCodeModal(
                        scope.row.OrganisationName.OrganisationId,
                        true
                      )
                    "
                  >
                    <span>{{ $t('text.poster_qr_code') }}</span>
                  </div>
                  <div
                    class="blue-font underline pointer inline-block ml-10"
                    @click="
                      openIdCardModal(scope.row.OrganisationName.OrganisationId)
                    "
                  >
                    <span>{{ $t('text.smartz_id_card') }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane
            :label="
              $t('text.patients', {
                patients: $firstLetterCapitalize($store.state.locale.patients)
              })
            "
            name="patients"
          >
            <el-checkbox v-model="showArchivedPatients" @change="getPatients()">{{
              $t('text.show_archived_patients', {
                patients: $firstLetterCapitalize($store.state.locale.patients)
              })
            }}</el-checkbox>
            <el-table
              border
              size="mini"
              height="calc(100vh - 300px)"
              max-height="800"
              :data="
                patients.filter(
                  data =>
                    !patientSearch ||
                    data.Alias.toLowerCase().includes(
                      patientSearch.toLowerCase()
                    )
                )
              "
              v-loading="loading"
            >
              <el-table-column :label="$t('text.alias')" prop="Alias">
                <template slot-scope="scope">
                  {{
                    scope.row.IsActive
                      ? scope.row.Alias
                      : `${scope.row.Alias} [${$t('text.archived')}]`
                  }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('text.action')">
                <template slot="header" slot-scope="scope">
                  <el-input
                    v-model="patientSearch"
                    size="mini"
                    :placeholder="
                      $t('text.please_enter_patient_alias_to_search', {
                        patient: $store.state.locale.patient
                      })
                    "
                  />
                </template>
                <template slot-scope="scope">
                  <div
                    class="blue-font underline pointer inline-block"
                    @click="openQRCodeModal(scope.row.PatientId, false)"
                  >
                    <span>{{ $t('text.poster_qr_code') }}</span>
                  </div>
                  <div
                    class="blue-font underline pointer inline-block ml-10"
                    @click="openCardQRCodeModal(scope.row.PatientId, false)"
                  >
                    <span>{{ $t('text.card_qr_code') }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <QRCodeModal ref="qrCodeModal" />
    <CardQRCodeModal ref="cardQRCodeModal" />
    <IDCardModal ref="idCardModal" />
  </div>
</template>

<script>
import QRCodeModal from '@/components/manage/observation/QRCodeModal.vue'
import CardQRCodeModal from '@/components/manage/observation/CardQRCodeModal.vue'
import IDCardModal from '@/components/manage/observation/IDCardModal.vue'
import ApiService from '@/services/ApiService.js'
import _ from 'lodash'
export default {
  data() {
    return {
      loading: false,
      patients: [],
      activeTab: 'common_area',
      patientSearch: '',
      showArchivedPatients: false
    }
  },
  computed: {
    organisations() {
      return this.$store.getters[`user/userOwnedOrganisations`].filter(
        item => !!item.Active
      )
    }
  },
  components: {
    QRCodeModal,
    CardQRCodeModal,
    IDCardModal
  },
  mounted() {
    this.getPatients()
  },
  watch: {
    '$store.state.filter.dashboardFilter': {
      handler: _.debounce(function() {
        this.getPatients()
      }, 100),
      deep: true
    }
  },
  methods: {
    getPatients() {
      this.loading = true
      ApiService.GetPatientsForObservation(
        this.$store.getters[`filter/calculatedFilter`].organisationId,
        this.$store.getters[`filter/calculatedFilter`].flag,
        this.$store.getters[`filter/calculatedFilter`].filterIds
      )
        .then(response => {
          this.loading = false
          this.patients = response.data.data || []
          if (!this.showArchivedPatients) {
            this.patients = this.patients.filter(item => item.IsActive)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    openQRCodeModal(patientId, isOrganization) {
      this.$refs.qrCodeModal.openDialog(patientId, isOrganization)
    },
    openCardQRCodeModal(patientId, isOrganization) {
      this.$refs.cardQRCodeModal.openDialog(patientId, isOrganization)
    },
    openIdCardModal(organisationId) {
      this.$refs.idCardModal.openDialog(organisationId)
    }
  }
}
</script>

<style lang="scss"></style>
